import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './PoTable.module.scss';
import { Thead } from '../Thead/Thead';
import { EmptyRow } from '../EmptyRow/EmptyRow';
import { AddressCell } from '../AddressCell/AddressCell';
import { LineItemsSubtable } from '../LineItemsSubtable/LineItemsSubtable';
import { StatusPill } from '../StatusPill/StatusPill';
import { money } from '../../utils';
import type { PoRecord } from '../../types';

interface PoTableProps {
  rows: PoRecord[];
}

export function PoTable({ rows }: PoTableProps) {
  const [open, setOpen] = useState<Record<string, boolean>>({});

  if (!rows.length) {
    return (
      <table className={styles.table}>
        <tbody>
          <EmptyRow label="No purchase orders yet." span={7} />
        </tbody>
      </table>
    );
  }

  return (
    <table className={styles.table}>
      <Thead
        cols={[
          'PO #',
          'Date',
          'Delivery address',
          'SKU lines',
          'Amount',
          'Status',
          '',
        ]}
      />
      <tbody>
        {rows.map((r) => {
          const isOpen = !!open[r.id];
          return (
            <React.Fragment key={r.id}>
              <tr
                className={styles.row}
                onClick={() => setOpen((o) => ({ ...o, [r.id]: !o[r.id] }))}
              >
                <td className={styles.number}>{r.number}</td>
                <td className={styles.text}>{r.date}</td>
                <AddressCell location={r.location} />
                <td className={styles.text}>{r.skus.length}</td>
                <td className={styles.amount}>{money(r.amount)}</td>
                <td className={styles.statusCell}>
                  <StatusPill status={r.status} />
                </td>
                <td className={styles.chevronCell}>
                  <ChevronDown
                    size={15}
                    className={
                      isOpen
                        ? `${styles.chevron} ${styles.chevronOpen}`
                        : styles.chevron
                    }
                  />
                </td>
              </tr>
              {isOpen && (
                <tr>
                  <td colSpan={7} className={styles.expandedCell}>
                    <LineItemsSubtable skus={r.skus} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
}
